import React, { useEffect, useState } from "react";
import { useAuth } from "./AppAuthContext";
import { Roles } from "../../firestore/Types/PermissionSchema";
import { StudentProvider } from "./StudentContext";
import { collection, limit, or, query, where } from "firebase/firestore";
import { nameofMessageSchemaCollection, nameofMessageSchemaIsRead, nameofMessageSchemaReceiverId } from "../../firestore/Types/MessageSchema";
import { db } from "../../firebase/firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { nameofNewBookingSchemaCollection, nameofNewBookingSchemaStudentId, nameofNewBookingSchemaTutorId } from "../../firestore/Types/NewBookingSchema";

const loggedInContext = React.createContext(
    {
        unreadMessages: 0 as number,
        pendingRequests: 0 as number,
    }
);

export function useLoggedIn() {
    return React.useContext(loggedInContext);
}

export function LoggedInProvider({ children }: { children: React.ReactNode }) {

    const { permission, currentUser } = useAuth();

    const messageRef = collection(db, nameofMessageSchemaCollection);
    const unreadMessageQuery = query(messageRef, where(nameofMessageSchemaReceiverId, "==", currentUser?.uid), where(nameofMessageSchemaIsRead, "==", false), limit(1));
    const [unreadMessageDocs] = useCollectionData(unreadMessageQuery);

    const requestRef = collection(db, nameofNewBookingSchemaCollection);
    const pendingRequestQuery = query(requestRef, or(where(nameofNewBookingSchemaStudentId, "==", currentUser?.uid), where(nameofNewBookingSchemaTutorId, "==", currentUser?.uid)), limit(1));
    const [pendingRequestDocs] = useCollectionData(pendingRequestQuery);

    const [unreadMessages, setUnreadMessages] = useState(0);
    const [pendingRequests, setPendingRequests] = useState(0);

    useEffect(() => {
        if (unreadMessageDocs) {
            setUnreadMessages(unreadMessageDocs.length);
        }
    }, [unreadMessageDocs]);

    useEffect(() => {
        if (pendingRequestDocs) {
            setPendingRequests(pendingRequestDocs.length);
        }
    }, [pendingRequestDocs]);

    const value = {
        unreadMessages,
        pendingRequests,
    }

    if (permission.Role === Roles.User) {
        return (
            <loggedInContext.Provider value={value}>
                <StudentProvider>
                    {children}
                </StudentProvider>
            </loggedInContext.Provider>
        )
    }

    return (
        <loggedInContext.Provider value={value}>
            {children}
        </loggedInContext.Provider>
    )
}